import { createSlice } from '@reduxjs/toolkit';

export const challengesSlice = createSlice({
  name: 'challenges',
  initialState: {
    list: [],
    meta: {},
    challengeDetails: {},
    challengeUsers: [],
    challengeUsersMeta: {},
    challengeUsersAnalytics: null,
    challengeRewards: [],
    challengeRewardsMeta: {},
    challengeRewardsAnalytics: null,
  },
  reducers: {
    // List
    getChallengesListRequest: () => {},
    getChallengesListResponse: (state, action) => {
      state.list = action.payload.challenges;
      state.meta = action.payload.meta;
    },

    // Details
    getChallengeDetailsRequest: () => {},
    getChallengeDetailsResponse: (state, action) => {
      state.challengeDetails = action.payload;
    },

    // Create / Edit / Draft
    createChallengeRequest: () => {},
    editChallengeRequest: () => {},
    saveChallengeAsDraftRequest: () => {},
    deleteDraftRequest: () => {},
    duplicateChallengeRequest: () => {},

    // Publish / Unpublish
    publishChallengeRequest: () => {},

    // Users list (embedded in ChallengeDetails)
    getChallengeUsersRequest: () => {},
    getChallengeUsersResponse: (state, action) => {
      state.challengeUsers = action.payload.users;
      state.challengeUsersMeta = action.payload.meta;
      state.challengeUsersAnalytics = action.payload.analytics;
    },

    // Selection submission (Quick Challenge, post-end audit) — bulk-submits
    // the audited winner set for reward disbursement.
    submitChallengeSelectionRequest: () => {},

    // Rewards list (post-submission)
    getChallengeRewardsRequest: () => {},
    getChallengeRewardsResponse: (state, action) => {
      state.challengeRewards = action.payload.rewards;
      state.challengeRewardsMeta = action.payload.meta;
      state.challengeRewardsAnalytics = action.payload.analytics;
    },
  },
});

export const {
  getChallengesListRequest,
  getChallengesListResponse,
  getChallengeDetailsRequest,
  getChallengeDetailsResponse,
  createChallengeRequest,
  editChallengeRequest,
  saveChallengeAsDraftRequest,
  deleteDraftRequest,
  duplicateChallengeRequest,
  publishChallengeRequest,
  getChallengeUsersRequest,
  getChallengeUsersResponse,
  getChallengeRewardsRequest,
  getChallengeRewardsResponse,
  submitChallengeSelectionRequest,
} = challengesSlice.actions;

export default challengesSlice.reducer;
